import { SERVER_API_URL } from '../app.constants';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ParamContext } from '../shared/service/param.context';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CategoricalTraitInfo, CharacterTraitInfo, NumericTraitInfo, TraitFilterRequest, TraitObservation, TraitReference, TraitResultRequest, TraitResultResponse } from './trait.reference.model';
import { createRequestOption } from '../shared';
import { TrialEnvironmentSearchRequest } from '../shared/query/model/trial-environment-search-request.model';
import { TrialEnvironmentSearchResponse } from '../shared/query/model/trial-environment-search-response.model';

@Injectable()
export class MultiTraitQueryService {
    private baseUrl = SERVER_API_URL;

    constructor(
        private http: HttpClient,
        private paramContext: ParamContext
    ) {
    }

    public getTraitClassTree(): Observable<TraitReference> {
        return this.http.get<TraitReference>(this.baseUrl + `crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/multi-trait/trait-class/tree`);
    }

    public getSearchResults(trialEnvironmentSearchRequest?: TrialEnvironmentSearchRequest, req ?: any): Observable<HttpResponse<TrialEnvironmentSearchResponse[]>> {
        const params = createRequestOption(req);
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/multi-trait/environment/search`;
        return this.http.post<TrialEnvironmentSearchResponse[]>(url, trialEnvironmentSearchRequest, {
            params,
            observe: 'response'
        });
    }

    getNumericTraits(traitFilter: TraitFilterRequest, req ?: any): Observable<HttpResponse<NumericTraitInfo[]>> {
        const params = createRequestOption(req);
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/multi-trait/numeric-trait-info`;
        return this.http.post<NumericTraitInfo[]>(url, traitFilter, {
            params,
            observe: 'response'
        });
    }

    getCategoricalTraits(traitFilter: TraitFilterRequest, req ?: any): Observable<HttpResponse<CategoricalTraitInfo[]>> {
        const params = createRequestOption(req);
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/multi-trait/categorical-trait-info`;
        return this.http.post<CategoricalTraitInfo[]>(url, traitFilter, {
            params,
            observe: 'response'
        });
    }

    getCharacterTraits(traitFilter: TraitFilterRequest, req ?: any) {
        const params = createRequestOption(req);
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/multi-trait/character-trait-info`;
        return this.http.post<CharacterTraitInfo[]>(url, traitFilter, {
            params,
            observe: 'response'
        });
    }

    public getTraitResults(traitResultRequest?: TraitResultRequest, req ?: any, returnAllResult: boolean = false): Observable<HttpResponse<TraitResultResponse[]>> {
        const params = createRequestOption(req);
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/multi-trait/trait-result?returnAllResult=${returnAllResult}`;
        return this.http.post<TraitResultResponse[]>(url, traitResultRequest, {
            params,
            observe: 'response'
        });
    }

    public getTraitObservation(traitFilter: TraitFilterRequest, req ?: any): Observable<HttpResponse<TraitObservation[]>> {
        const params = createRequestOption(req);
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/multi-trait/observations`;
        return this.http.post<TraitObservation[]>(url, traitFilter, {
            params,
            observe: 'response'
        });
    }

    public getTraitTypeLocations(traitFilter: TraitFilterRequest): Observable<HttpResponse<string[]>> {
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/multi-trait/locations`;
        return this.http.post<string[]>(url, traitFilter, { observe: 'response' });
    }
}
